var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import gsap from 'gsap';
import './main.scss';
var data = {
    backgroundSolidColor: '#005f9e',
};
var defaultProps = {
    data: data,
};
var themes = [
    {
        background: '',
        backgroundColor: '#005f9e',
        color: '#ffffff',
        ctaStyle: { backgroundColor: '#ffffff', color: '#0074bd' },
    },
    {
        background: '',
        backgroundColor: '#343741',
        color: '#ffffff',
        ctaStyle: { backgroundColor: '#ffffff', color: '#0074bd' },
    },
    {
        background: '',
        backgroundColor: '#d8dcdb',
        color: '#343741',
        ctaStyle: { backgroundColor: '#005f9e', color: '#343741' },
    },
    {
        background: '',
        backgroundColor: '#454545',
        color: '#ffffff',
        ctaStyle: { backgroundColor: '#ffffff', color: '#005f9e' },
    },
];
var CenteredHeadlineCTA = function (_a) {
    var _b = _a.data, headlineText = _b.headlineText, backgroundSolidColor = _b.backgroundSolidColor, backgroundImage = _b.backgroundImage, cta = _b.cta;
    var chosentheme = themes[0];
    var themeIndex = themes.findIndex(function (_a) {
        var backgroundColor = _a.backgroundColor;
        return backgroundColor.toLowerCase() ===
            (backgroundSolidColor === null || backgroundSolidColor === void 0 ? void 0 : backgroundSolidColor.toLocaleLowerCase());
    });
    if (backgroundImage) {
        chosentheme = __assign(__assign({}, themes[3]), { background: "URL(" + backgroundImage + ")" });
    }
    else if (themeIndex >= 0) {
        chosentheme = themes[themeIndex];
    }
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.centered-headline-cta-section',
                start: 'top center',
            },
        });
        tl.fromTo(['.centered-headline-cta-text', '.centered-headline-cta-button'], {
            opacity: 0,
            duration: 0.5,
            stagger: 0.5,
        }, {
            opacity: 1,
            duration: 0.5,
            stagger: 0.5,
        });
    }, []);
    return (_jsxs("div", __assign({ className: "centered-headline-cta-section relative snap-center w-full h-full flex items-center justify-center", style: chosentheme }, { children: [backgroundImage && _jsx("div", { className: "centered-headline-cta-overlay" }, void 0),
            _jsxs("span", __assign({ className: "text-center " + ((cta === null || cta === void 0 ? void 0 : cta.url) !== '' && (cta === null || cta === void 0 ? void 0 : cta.label) !== null
                    ? 'centered-headline-cta-textWrapper'
                    : 'py-[90px] px-[24px] lg:py-[125px]') }, { children: [_jsx("p", __assign({ className: "centered-headline-cta-text text-center w-full" }, { children: headlineText }), void 0),
                    (cta === null || cta === void 0 ? void 0 : cta.url) !== '' && (cta === null || cta === void 0 ? void 0 : cta.label) !== null && (_jsx("a", __assign({ className: "centered-headline-cta-button centered-headline-cta-button--animate", href: cta === null || cta === void 0 ? void 0 : cta.url, style: {
                            color: chosentheme.ctaStyle.color,
                            backgroundColor: chosentheme.ctaStyle.backgroundColor,
                        } }, { children: _jsx("span", { children: cta === null || cta === void 0 ? void 0 : cta.label }, void 0) }), void 0))] }), void 0)] }), void 0));
};
export default CenteredHeadlineCTA;
CenteredHeadlineCTA.defaultProps = defaultProps;
